import {
    Component,
    OnInit,
    Input,
    Output,
    EventEmitter,
    OnChanges,
    SimpleChanges,
} from "@angular/core";
import { Status } from "src/app/models/statusEnums"; //'src/app/models/statusEnums';
import { AppMainService } from "src/app/app-main.service";
import { AppMainComponent } from "src/app/app.main.component";
import { MessageService } from "primeng/api";
import { AccountService } from "src/app/accounts/accountService";
import { LeadService } from "src/app/leads/leadService";
import { ContactService } from "src/app/contacts/contactService";
import { OpportunityService } from "src/app/opportunities/opportunity.service";

@Component({
    selector: "app-lion-active-inactive-modal",
    templateUrl: "./active-inactive-modal.component.html",
    styleUrls: ["./active-inactive-modal.component.css"]
})

export class LionActiveInActiveModalComponent implements OnInit, OnChanges {

    @Input() commentHeaderName: string;
    @Input() displayActiveInactiveModal = false;
    @Input() id;
    @Input() contactAssociationTypeId: number;
    @Input() statusId;
    @Input() moduleName;
    @Input() activeInactiveFormType;
    @Input() activeInactiveData;
    @Output() cancelActiveInactiveModal = new EventEmitter<any>();
    @Output() saveActiveInactiveModal = new EventEmitter<any>();
    // id : number;
    // statusId : number;
    selectedAccountComments: any;
    commentObject = {
        isActive: false,
        comment: "",
        reasonId: []
    };
    commentObjectId: number;
    // commentHeaderName: string;
    commentInvalid: boolean = false;
    activatingReason: Array<any>;
    inActivatingReason: Array<any>;
    selectedActiveReasons: Array<any>;
    selectedInactiveReasons: Array<any>;
    reasonIds: Array<any>;
    reasonsList: Array<any>;
    filterReasonList: boolean = false;
    reasonsValidation: boolean = false;
    currentStatus: string;

    constructor(
        private appMainService: AppMainService,
        private messageService: MessageService,
        private leadService: LeadService,
        private accountService: AccountService,
        private contactService: ContactService,
        private opportunityService: OpportunityService
    ) {
    }

    ngOnInit(): void {
        //console.log(this.activeInactiveData);
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes?.id?.currentValue) {
            //onActiveInactiveResource(this.id, this.statusId);
            this.onActiveInactiveResource(this.id, this.statusId);
        }
        if (changes?.activeInactiveData?.currentValue){
            this.onActiveInactiveResouceForActivity();
        }

        if(changes?.contactAssociationTypeId?.currentValue){
            this.contactAssociationTypeId = changes?.contactAssociationTypeId?.currentValue;
        }
    }

    onActiveInactiveResource(id, statusId) {
        if (this.moduleName == "Lead") {
            this.getActiveInActiveReasonForLead('LeadActivatedReason');
            this.getActiveInActiveReasonForLead('LeadInactivatedReason');
        } else if (this.moduleName == "Account"){
            this.getActiveInActiveReasonForAccount('AccountActivatedReason');
            this.getActiveInActiveReasonForAccount('AccountInactivatedReason');
        } else if (this.moduleName == "Contacts"){
            this.getActiveInActiveReasonForContact('ContactActivatedReason');
            this.getActiveInActiveReasonForContact('ContactInactivatedReason');
        } else if (this.moduleName == "Opportunity"){
            this.getActiveInActiveReasonForOpportunity('ActivatedReason');
            this.getActiveInActiveReasonForOpportunity('InactivatedReason');
        }

        this.commentObjectId = id;
        //this.selectedActiveInactiveReasons
        this.commentObject = {
            isActive: statusId == Status.Active ? false : true,
            comment: "",
            reasonId: []
        };
        const status = this.commentObject.isActive
            ? "Activating"
            : "Inactivating";
        this.currentStatus = status;
        this.commentHeaderName = `Confirmation for ${status} the ${this.moduleName}`;
    }

    onActiveInactiveResouceForActivity(){
        if (this.moduleName == "Lead") {
            this.getActiveInActiveReasonForLead('LeadActivatedReason', true);
            this.getActiveInActiveReasonForLead('LeadInactivatedReason', true);
        } else if (this.moduleName == "Account"){
            this.getActiveInActiveReasonForAccount('AccountActivatedReason', true);
            this.getActiveInActiveReasonForAccount('AccountInactivatedReason', true);
        }
        else if (this.moduleName == "Contacts"){
            this.getActiveInActiveReasonForContact('ContactActivatedReason', true);
            this.getActiveInActiveReasonForContact('ContactInactivatedReason', true);
        } else if (this.moduleName == "Opportunity"){
            this.getActiveInActiveReasonForOpportunity('ActivatedReason', true);
            this.getActiveInActiveReasonForOpportunity('InactivatedReason', true);
        }
    }

    saveComment() {
        if (!this.commentObject.comment.trim()) {
            this.commentInvalid = true;
            this.currentStatus == 'Activating' ? this.isReasonEmptyForActiviting(): this.isReasonEmptyForIncctiviting();
        }
        else {
            this.commentInvalid = false;
            this.reasonsValidation = false;

            if (this.moduleName == "Lead") {
                this.saveCommentsForLead();
            } else if (this.moduleName == "Account") {
                this.saveCommentsForAccount();
            } else if (this.moduleName == "Contacts"){
                this.saveCommentsForContact();
            } else if (this.moduleName == "Opportunity"){
                this.saveCommentsForOpportunity();
            }
        }
    }

    cancelComment() {
        this.commentObject = {
            isActive: false,
            comment: "",
            reasonId: []
        };
        this.commentInvalid = false;
        this.reasonsValidation = false;
        this.displayActiveInactiveModal = false;
        this.commentObjectId = null;
        this.cancelActiveInactiveModal.emit();
    }

    saveCommentAction(){
        this.commentObject = {
            isActive: false,
            comment: "",
            reasonId: []
        };
        this.commentInvalid = false;
        this.displayActiveInactiveModal = false;
        this.commentObjectId = null;
        this.reasonsValidation = false;
        this.reasonIds = [];
        this.saveActiveInactiveModal.emit();
    }

    getActiveInActiveReasonForLead(type: string, filterReasonList? : boolean): void {
        this.appMainService.isShowSpinner("getActiveInactiveData");
        this.leadService.getActiveInactiveDataByName(type).subscribe(
            dataName => {
                dataName &&
                    this.leadService.getActiveInactiveReasons(dataName.id).subscribe(
                        (res) => {
                            if (type == 'LeadActivatedReason') {
                                this.activatingReason = res ? res.filter(x => x.statusId == 1) : [];
                                this.selectedActiveReasons = res ? res.filter(x => x.isDefault == true) : [];
                                if (filterReasonList && this.activeInactiveData?.objectData?.status?.id == 1){
                                    const reasonObj = this.activeInactiveData?.objectData?.objectStageAuditReason;
                                    this.reasonsList = this.activatingReason.filter((el) => {
                                        return reasonObj.some((data) => {
                                            return data.reasonId == el.id;
                                        })
                                    });
                                }
                            } else {
                                this.inActivatingReason = res ? res.filter(x => x.statusId == 1) : [];
                                this.selectedInactiveReasons = res ? res.filter(x => x.isDefault == true) : [];
                                if (filterReasonList && this.activeInactiveData?.objectData?.status?.id == 2){
                                    const reasonObj = this.activeInactiveData?.objectData?.objectStageAuditReason;
                                    this.reasonsList = this.inActivatingReason.filter((el) => {
                                        return reasonObj.some((data) => {
                                            return data.reasonId == el.id;
                                        })
                                    });
                                }
                            }
                            this.appMainService.isHideSpinner('getActiveInactiveData');
                        },
                        err => {
                            this.appMainService.isHideSpinner('getActiveInactiveData');
                        });
            },
            (error) => {
                this.appMainService.isHideSpinner('getActiveInactiveData');
        });
    }

    onChangeActiveReason($event = null){
        const selectedActiveReasons = $event ? $event.value : this.selectedActiveReasons;
        this.reasonIds = selectedActiveReasons.map(x => x.id).sort((a, b) => a -b);
        this.reasonIds.length > 0 ? this.reasonsValidation = false : this.reasonsValidation = true;
    }

    onChangeInactiveReason($event = null){
        const selectedInactiveReasons = $event ? $event.value : this.selectedInactiveReasons;
        this.reasonIds = selectedInactiveReasons.map(x => x.id).sort((a, b) => a -b);
        this.reasonIds.length > 0 ? this.reasonsValidation = false : this.reasonsValidation = true;
    }

    isReasonEmptyForActiviting(): void{
        this.onChangeActiveReason();
        this.reasonIds.length === 0 ? this.reasonsValidation = true : this.reasonsValidation = false;
    }

    isReasonEmptyForIncctiviting(): void{
        this.onChangeInactiveReason();
        this.reasonIds.length === 0 ? this.reasonsValidation = true : this.reasonsValidation = false;
    }

    saveCommentsForLead(): void {
        if (this.statusId == Status.Active){
            this.onChangeInactiveReason();
            this.commentObject.reasonId = this.reasonIds;
            if (this.commentObject.reasonId.length == 0){
                this.reasonsValidation = true;
                return;
            }

        }
        if (this.statusId == Status.InActive){
            this.onChangeActiveReason();
            this.commentObject.reasonId = this.reasonIds;
            if (this.commentObject.reasonId.length == 0){
                this.reasonsValidation = true;
                return;
            }
        }
        this.appMainService.isShowSpinner("saveComments");
        this.leadService.activeInactiveLead(this.commentObjectId, this.commentObject).then(
            (response) => {
                const status = this.commentObject.isActive
                    ? "Activated"
                    : "Deactivated";
                this.messageService.add({
                    severity: "success",
                    summary: "Success",
                    detail: "Lead " + status + " Sucessfully...",
                });
                this.saveCommentAction();
                this.appMainService.isHideSpinner("saveComments");
            })
            .catch((err) => {
                const status = this.commentObject.isActive
                    ? "Activated"
                    : "Deactivated";
                this.messageService.add({
                    severity: "error",
                    summary: "Error",
                    detail: "Error occurred while " + status + " Lead...",
                });
                this.appMainService.isHideSpinner("saveComments");
            });
    }

    getActiveInActiveReasonForAccount(type: string, filterReasonList? : boolean): void {
        this.appMainService.isShowSpinner("getActiveInactiveData");

        this.accountService.getActiveInactiveDataByName(type).subscribe(
            dataName => {
                dataName &&
                    this.accountService.getActiveInactiveReasons(dataName.id).subscribe(
                        (res) => {
                            if (type == 'AccountActivatedReason') {
                                this.activatingReason = res ? res.filter(x => x.statusId == 1) : [];
                                this.selectedActiveReasons = res ? res.filter(x => x.isDefault == true) : [];
                                if (filterReasonList && this.activeInactiveData?.objectData?.status?.id == 1){
                                    const reasonObj = this.activeInactiveData?.objectData?.objectStageAuditReason;
                                    this.reasonsList = this.activatingReason.filter((el) => {
                                        return reasonObj.some((data) => {
                                            return data.reasonId == el.id;
                                        })
                                    });
                                }
                            } else {
                                this.inActivatingReason = res ? res.filter(x => x.statusId == 1) : [];
                                this.selectedInactiveReasons = res ? res.filter(x => x.isDefault == true) : [];
                                if (filterReasonList && this.activeInactiveData?.objectData?.status?.id == 2){
                                    const reasonObj = this.activeInactiveData?.objectData?.objectStageAuditReason;
                                    this.reasonsList = this.inActivatingReason.filter((el) => {
                                        return reasonObj.some((data) => {
                                            return data.reasonId == el.id;
                                        })
                                    });
                                }
                            }
                            this.appMainService.isHideSpinner('getActiveInactiveData');
                        },
                        () => {
                            this.appMainService.isHideSpinner('getActiveInactiveData');
                        });
            },
            () => {
                this.appMainService.isHideSpinner('getActiveInactiveData');
        });
    }

    saveCommentsForAccount(): void {
        if (this.statusId == Status.Active){
            this.onChangeInactiveReason();
            this.commentObject.reasonId = this.reasonIds;
            if (this.commentObject.reasonId.length == 0){
                this.reasonsValidation = true;
                return;
            }
        }
        if (this.statusId == Status.InActive){
            this.onChangeActiveReason();
            this.commentObject.reasonId = this.reasonIds;
            if (this.commentObject.reasonId.length == 0){
                this.reasonsValidation = true;
                return;
            }
        }
        this.appMainService.isShowSpinner("saveComments");
        this.accountService.activeInactiveAccount(this.commentObjectId, this.commentObject)
            .then(() => {
                const status = this.commentObject.isActive ? "Activated" : "Deactivated";
                this.messageService.add({
                    severity: "success",
                    summary: "Success",
                    detail: "Account " + status + " Sucessfully...",
                });
                this.saveCommentAction();
                this.appMainService.isHideSpinner("saveComments");
            })
            .catch(() => {
                const status = this.commentObject.isActive ? "Activated" : "Deactivated";
                this.messageService.add({
                    severity: "error",
                    summary: "Error",
                    detail: "Error occurred while " + status + " Account...",
                });
                this.appMainService.isHideSpinner("saveComments");
            });
    }

    getActiveInActiveReasonForContact(type: string, filterReasonList? : boolean): void {
        this.appMainService.isShowSpinner("getActiveInactiveData");
        this.contactService.getActiveInactiveDataByName(type).subscribe(
            dataName => {
                dataName &&
                    this.contactService.getActiveInactiveReasons(dataName.id).subscribe(
                        (res) => {
                            if (type == 'ContactActivatedReason') {
                                this.activatingReason = res ? res.filter(x => x.statusId == 1) : [];
                                this.selectedActiveReasons = res ? res.filter(x => x.isDefault == true) : [];
                                if (filterReasonList && this.activeInactiveData?.objectData?.status?.id == 1){
                                    const reasonObj = this.activeInactiveData?.objectData?.objectStageAuditReason;
                                    this.reasonsList = this.activatingReason.filter((el) => {
                                        return reasonObj.some((data) => {
                                            return data.reasonId == el.id;
                                        })
                                    });
                                }
                            } else {
                                this.inActivatingReason = res ? res.filter(x => x.statusId == 1) : [];
                                this.selectedInactiveReasons = res ? res.filter(x => x.isDefault == true) : [];
                                if (filterReasonList && this.activeInactiveData?.objectData?.status?.id == 2){
                                    const reasonObj = this.activeInactiveData?.objectData?.objectStageAuditReason;
                                    this.reasonsList = this.inActivatingReason.filter((el) => {
                                        return reasonObj.some((data) => {
                                            return data.reasonId == el.id;
                                        })
                                    });
                                }
                            }
                            this.appMainService.isHideSpinner('getActiveInactiveData');
                        },
                        err => {
                            this.appMainService.isHideSpinner('getActiveInactiveData');
                        });
            },
            (error) => {
                this.appMainService.isHideSpinner('getActiveInactiveData');
        });
    }

    saveCommentsForContact() {
         if (this.statusId == Status.Active){
            this.onChangeInactiveReason();
            this.commentObject.reasonId = this.reasonIds;
            if (this.commentObject.reasonId.length == 0){
                this.reasonsValidation = true;
                return;
            }
        }
        if (this.statusId == Status.InActive){
            this.onChangeActiveReason();
            this.commentObject.reasonId = this.reasonIds;
            if (this.commentObject.reasonId.length == 0){
                this.reasonsValidation = true;
                return;
            }
        }

        const statusData = {
            ...this.commentObject,
            contactId: this.commentObjectId,
            contactAssociationTypeId: this.contactAssociationTypeId
        }

        this.appMainService.isShowSpinner("saveComments");
        this.contactService.activeInactiveContact(statusData)
            .then(() => {
                const status = this.commentObject.isActive ? "Activated" : "Deactivated";
                this.messageService.add({
                    severity: "success",
                    summary: "Success",
                    detail: "Contact " + status + " Sucessfully...",
                });
                this.saveCommentAction();
                this.appMainService.isHideSpinner("saveComments");
            })
            .catch((err) => {
                // const status = this.commentObject.isActive ? "Activated" : "Deactivated";
                this.messageService.add({
                    severity: "error",
                    summary: "Error",
                    detail: err?.error?.Message,
                });
                this.appMainService.isHideSpinner("saveComments");
            });
    }

    getActiveInActiveReasonForOpportunity(type: string, filterReasonList? : boolean): void {
        this.appMainService.isShowSpinner("getActiveInactiveData");
        this.opportunityService.getActiveInactiveDataByName(type).subscribe(
            dataName => {
                dataName &&
                    this.opportunityService.getActiveInactiveReasons(dataName.id).subscribe(
                        (res) => {
                            if (type == 'ActivatedReason') {
                                this.activatingReason = res ? res.filter(x => x.statusId == 1) : [];
                                this.selectedActiveReasons = res ? res.filter(x => x.isDefault == true) : [];
                                if (filterReasonList && this.activeInactiveData?.objectData?.status?.id == 1){
                                    const reasonObj = this.activeInactiveData?.objectData?.objectStageAuditReason;
                                    this.reasonsList = this.activatingReason.filter((el) => {
                                        return reasonObj.some((data) => {
                                            return data.reasonId == el.id;
                                        })
                                    });
                                }
                            } else {
                                this.inActivatingReason = res ? res.filter(x => x.statusId == 1) : [];
                                this.selectedInactiveReasons = res ? res.filter(x => x.isDefault == true) : [];
                                if (filterReasonList && this.activeInactiveData?.objectData?.status?.id == 2){
                                    const reasonObj = this.activeInactiveData?.objectData?.objectStageAuditReason;
                                    this.reasonsList = this.inActivatingReason.filter((el) => {
                                        return reasonObj.some((data) => {
                                            return data.reasonId == el.id;
                                        })
                                    });
                                }
                            }
                            this.appMainService.isHideSpinner('getActiveInactiveData');
                        },
                        err => {
                            this.appMainService.isHideSpinner('getActiveInactiveData');
                        });
            },
            (error) => {
                this.appMainService.isHideSpinner('getActiveInactiveData');
        });
    }

    saveCommentsForOpportunity() {
        if (this.statusId == Status.Active){
            this.onChangeInactiveReason();
            this.commentObject.reasonId = this.reasonIds;
            if (this.commentObject.reasonId.length == 0){
                this.reasonsValidation = true;
                return;
            }
        }
        if (this.statusId == Status.InActive){
            this.onChangeActiveReason();
            this.commentObject.reasonId = this.reasonIds;
            if (this.commentObject.reasonId.length == 0){
                this.reasonsValidation = true;
                return;
            }
        }
        this.appMainService.isShowSpinner("saveComments");
        this.opportunityService.activeInactiveOpportunity(this.commentObjectId, this.commentObject)
            .then(() => {
                const status = this.commentObject.isActive ? "Activated" : "Deactivated";
                this.messageService.add({
                    severity: "success",
                    summary: "Success",
                    detail: "Opportunity " + status + " Sucessfully...",
                });
                this.saveCommentAction();
                this.appMainService.isHideSpinner("saveComments");
            })
            .catch(() => {
                const status = this.commentObject.isActive ? "Activated" : "Deactivated";
                this.messageService.add({
                    severity: "error",
                    summary: "Error",
                    detail: "Error occurred while " + status + " Opportunity...",
                });
                this.appMainService.isHideSpinner("saveComments");
            });
    }
}
